import React, { FC } from "react";
import Form from "react-bootstrap/Form";
import TextField from "@mui/material/TextField";
import { Input, InputLabel, FormControl } from "@mui/material";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

interface IInputDateRangePicker {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleClose: any;
  handleBlur: any;
  errorsField: any;
  touched: any;
  value: any;
  autofocus?: any;
  readOnly?: any;
  disabled?: any;
  position?: any;
}

/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleClose: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, readOnly, disabled
}
 * @returns {*}
 */
const InputDateRangePicker: FC<IInputDateRangePicker> = ({
  controlId,
  label,
  placeholder,
  handleChange,
  handleClose,
  handleBlur,
  errorsField,
  touched,
  value,
  autofocus,
  readOnly,
  disabled,
  position,
}) => {
  return (
    <FormControl fullWidth error={errorsField && touched}>
      <Form.Group className="mb-3 pb-1" controlId={controlId}>
        <div className="position-relative date-picker-icon"></div>
        <DateRangePicker
          name={controlId}
          onChange={handleChange}
          format="MM/dd/yyyy"
          placeholder={placeholder}
          placement={position ? position : "bottomStart"}
          defaultValue={value}
        />
      </Form.Group>
    </FormControl>
  );
};

export default InputDateRangePicker;
